import React from 'react';
import SystemEditor from './SystemEditor';

function createEditor( system, props ) {
  if ( system == null ) {
    return null;
  }
  props = props || {};
  props.system = system;
  return <SystemEditor {...props} /> 
}

module.exports = {
  createEditor
}
